import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Twitter } from 'lucide-react';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-top">
        <section className="footer-brand-block" id="waitlist">
          <Link to="/" className="footer-brand" aria-label="Apex Breath home">
            <img src="/apex_icon.jpeg" alt="Apex Breath icon" className="footer-brand-icon" />
            <span>Apex Breath</span>
          </Link>
          <p>Activity-based breathwork for sport, focus, and recovery.</p>
        </section>

        <nav className="footer-link-group" aria-label="Quick links">
          <h3>Quick links</h3>
          <a href="/#features">Features</a>
          <a href="/#use-cases">Use Cases</a>
          <a href="/#social-proof">Social proof</a>
          <a href="/#numbers">Numbers</a>
          <a href="/#ai-suggestions">AI Suggestions</a>
        </nav>

        <nav className="footer-link-group" aria-label="Pages">
          <h3>Pages</h3>
          <Link to="/why-activity">About</Link>
          <a href="/#waitlist">Waitlist</a>
          <a href="/#testimonials">Changelog</a>
          <a href="/404">Error 404</a>
        </nav>

        <nav className="footer-link-group" aria-label="Support">
          <h3>Support</h3>
          <a href="/#faqs">FAQs</a>
          <a href="https://www.fireislanddesign.com/contact" target="_blank" rel="noopener noreferrer">
            Contact
          </a>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
        </nav>
      </div>

      <div className="footer-bottom">
        <p><a href="https://fireislanddesign.com">Designed by Fire Island Design.</a></p>
        <div className="footer-socials">
          <a href="https://www.instagram.com/fireislanddesignco" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <Instagram size={22} />
          </a>
          <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <Linkedin size={22} />
          </a>
          <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <Facebook size={22} />
          </a>
          <a href="https://x.com" target="_blank" rel="noopener noreferrer" aria-label="X">
            <Twitter size={22} />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
